import SequenceView from './SequenceView';

export default SequenceView;